import Page from "components/Page";
import React, { useState, useEffect } from "react";
import styles from "./../../../ManageSystemInstructions/SystemInstruction.module.scss";
import chatStyles from "../reportedResponses.module.scss";
import { withTranslation } from "react-i18next";
import constants from "../../../../../../constants";
import Card from "components/Card";
import Text from "components/Text";
import moment from "moment";
import {
  reportViewCommentAddedBySuperAdmin,
  seenResponseReported,
} from "repositories/ai-assistant-repository";
import { formatLocalDateTime, handleError, handleSuccess } from "utils";

function ViewReportedResponseDetails({ t, location, history }) {
  const session = location?.state || {};
  const [comment, setComment] = useState(session?.commentBySuperAdmin);
  const reportOptions = constants.reportOptions;
  const goBack = () =>
    history.push({ pathname: constants.routes.aiAssistant.reportedResponse });

  useEffect(() => {
    if (session?.reviewStatus == "Seen") return;
    seenReportDetail();
  }, []);

  const seenReportDetail = async () => {
    if (!session?.id) return;
    try {
      await seenResponseReported(session?.id);
    } catch (error) {
      handleError(error);
    }
  };

  const commentGivenBySuperAdmin = async () => {
    try {
      const params = {
        id: session?.id,
        commentBySuperAdmin: comment,
      };

      const result = await reportViewCommentAddedBySuperAdmin(params);
      handleSuccess(result?.message);
      goBack();
    } catch (error) {
      handleError(error);
    }
  };

  const renderHeader = () => (
    <div className="content_wrapper_pms">
      <div>
        <h2 className="title pms_heading page_title_margin_top page_title_margin_bottom">
          {t("aiAssistant.responseReport")}
        </h2>
        <Text size="14px" weight="300" color="#000000">
          {t("aiAssistant.aiAssistSubheading")}
        </Text>
      </div>
    </div>
  );

  const renderInfoRow = (label, value) => (
    <div className={chatStyles["chat-info-row"]}>
      <div className={chatStyles["chat-info-label"]}>{label}</div>
      <div className={chatStyles["chat-info-value"]}>{value || "--"}</div>
    </div>
  );

  const renderDetails = () => (
    <div className={chatStyles["chat-info-panel"]}>
      {renderInfoRow(
        t("aiAssistant.ratingReviews.username"),
        `${session?.user?.firstName} ${session?.user?.lastName}`,
      )}
      {renderInfoRow(
        t("aiAssistant.ratingReviews.emailAddresss"),
        session?.user?.emailId,
      )}
      {renderInfoRow(
        t("aiAssistant.ratingReviews.accountOwner"),
        `${session?.owner?.firstName} ${session?.owner?.lastName}`,
      )}
      {renderInfoRow(
        t("aiAssistant.ratingReviews.date"),
        session?.createdAt
          ? formatLocalDateTime(session.createdAt, "MMM DD, YYYY")
          : "--",
      )}
      {renderInfoRow(
        t("aiAssistant.ratingReviews.reason"),
        reportOptions.find((option) => option.id === session?.reportType)
          ?.title || "--",
      )}
      {renderInfoRow(
        t("aiAssistant.ratingReviews.additionalComment"),
        session?.commentByUser || "--",
      )}
      {renderInfoRow(
        t("aiAssistant.ratingReviews.queryAsked"),
        session?.userMessage,
      )}
      {renderInfoRow(
        t("aiAssistant.ratingReviews.responseReceived"),
        session?.aiResponse,
      )}

      <div>
        <Text size="13px" weight="400" color="#79869A" lineHeight="14px">
          {t("aiAssistant.ratingReviews.addComment")}
        </Text>
        <Text
          size="11px"
          weight="500"
          color="#79869A"
          marginBottom="6px"
          marginTop="4px"
        >
          {t("aiAssistant.ratingReviews.commentNotVisible")}
        </Text>
        <div className="c-field">
          <textarea
            className="c-form-control bg-transparent"
            name="comment"
            placeholder={t("taskManagement.addComment")}
            maxLength={1000}
            rows="5"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <span className={chatStyles["character-remaining-msg"]}>
            {`${t("aiAssistant.ratingReviews.characterRemaining")} ${
              1000 - (comment?.length || 0)
            }/1000`}
          </span>
        </div>
      </div>
      <div>
        <button
          className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
          onClick={() => commentGivenBySuperAdmin()}
        >
          {t("save")}
        </button>
        <button
          className="button button-round button-border button-dark btn-mobile-link"
          onClick={goBack}
        >
          {t("cancel")}
        </button>
      </div>
    </div>
  );

  return (
    <>
      <Page onBack={() => goBack()} className={styles["global-main-page"]}>
        {renderHeader()}
        <Card className={styles.instruction_card + " custom-table"}>
          <div className={chatStyles["chat-details-container"]}>
            {renderDetails()}
          </div>
        </Card>
      </Page>
    </>
  );
}

export default withTranslation()(ViewReportedResponseDetails);
